import axios from 'axios';

export default {
	registerDevice(deviceData) {
		return axios.post('/api/users/me/devices', deviceData);
	},
	unregisterDevice(id) {
		return axios.delete(`/api/users/me/devices/${id}`);
	},
	getApplicationServerKey() {
		return axios.get('/api/vapid');
	},
};
